'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/change-password-complete.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _button = require('@marmalade/button');
var _girlAtDeskSuccess = require('../../images/girl-at-desk-success.svg');
var _girlAtDeskSuccess2 = _interopRequireDefault(_girlAtDeskSuccess);
var _accountPanel = require('./account-panel');
var _accountPanel2 = _interopRequireDefault(_accountPanel);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ChangePasswordComplete = function (_Component) {
  _inherits(ChangePasswordComplete, _Component);
  function ChangePasswordComplete() {
    _classCallCheck(this, ChangePasswordComplete);
    return _possibleConstructorReturn(this, (ChangePasswordComplete.__proto__ || Object.getPrototypeOf(ChangePasswordComplete)).apply(this, arguments));
  }
  _createClass(ChangePasswordComplete, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_accountPanel2.default, {
        img: _girlAtDeskSuccess2.default,
        alt: 'Girl at desk',
        icon: 'tick',
        title: 'Password updated',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 15
        },
        __self: this
      }, _react2.default.createElement(_glamorous2.default.P, {
        css: {
          textAlign: 'center'
        },
        __source: {
          fileName: _jsxFileName,
          lineNumber: 16
        },
        __self: this
      }, 'Your password has been successfully set.'), _react2.default.createElement(_button.LinkButton, {
        to: this.props.redirect,
        block: true,
        prominence: 'primary',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 17
        },
        __self: this
      }, 'Continue'));
    }
  }]);
  return ChangePasswordComplete;
}(_react.Component);
ChangePasswordComplete.propTypes = {
  redirect: _propTypes.string.isRequired
};
exports.default = ChangePasswordComplete;